"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var randomNumber = exports.randomNumber = function randomNumber() {
  return Math.random().toFixed(15).slice(2);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-ratings-declarative/build/utils.js
// module id = 457
// module chunks = 0